module.exports = __webpack_public_path__ + "img/月发电量 (1).4b41bc49.png";